import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { AppRoutes } from '@/routes';
import { ToastProvider } from '@/components/Toast';

export function App() {
  return (
    <ToastProvider>
      <div className="flex min-h-screen flex-col bg-white">
        <Header />
        <main className="flex-1">
          <AppRoutes />
        </main>
        <Footer />
      </div>
    </ToastProvider>
  );
}

export default App;
